import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pie-chart",
  "use": "icon-pie-chart-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-pie-chart\" id=\"icon-pie-chart\"><path d=\"M21.21 15.89A10 10 0 1 1 8 2.83\" /><path d=\"M22 12A10 10 0 0 0 12 2v10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol